// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.material-table {
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 4px;
    background-color: #FFFFFF !important;
}

div.material-table .load-bar {
    position: absolute;
    top: 57.5px;
}

/** SCROLL BAR **/
div.material-table .table-scroll::-webkit-scrollbar-thumb:hover {
    background: #124824;
}

div.material-table .table-scroll::-webkit-scrollbar {
    margin-right: -5px;
    width: 5px;
    height: 5px;
    border-radius: 5px;
}

div.material-table .table-scroll::-webkit-scrollbar-track {
    background: #d8d8d8;
    margin-top: 61.5px;
    position: absolute;
}

div.material-table .table-scroll::-webkit-scrollbar-thumb {
    background: #098442;
}

div.material-table .table-scroll::-webkit-scrollbar-thumb:hover {
    background: #124824;
}

/*****/

div.material-table .table-body .table-row:nth-child(odd) {
    background-color: #F4F4F4;
}

div.material-table tr.table-header th {
    background-color: #004B22 !important;
    color: #FFFFFF !important;;
    position: sticky !important;
    top: 0 !important;
    z-index: 1;
    height: 50px !important;
    font: 500 13px/37px 'Roboto';
}

div.material-table tr.table-header th:nth-child(1) {
    border-top-left-radius: 4px;
}
div.material-table tr.table-header th:last-child {
    border-top-right-radius: 4px;
}

div.material-table tr.table-padding th {
    padding: 4px 4px 4px 4px;
}


div.material-table span.sort-header:hover,
div.material-table span.sort-header:focus,
div.material-table span.sort-header.MuiTableSortLabel-active {
    color: #FFFFFF;
    font-weight: bold;
    fill: #FFFFFF !important;
}

div.material-table span.sort-header > svg {
    fill: #FFFFFF !important;
}

div.material-table tr.table-padding td {
    padding: 4px 4px 4px 4px;
}

div.material-table td > span.cell-value {
    color: #424242;
    font: normal 12px/37px 'Roboto';
}

/* Dimensions */
.wfill {width: 100% !important;}
.hfill {height: 100% !important;}

/* Flexbox */

.flx1 { display: flex !important; flex: 1 !important; }
.fdc {
    display: flex !important;
    flex-direction: column !important;
}


.oxo {overflow-x: overlay !important;}
.oyo {overflow-y: overlay !important;}

.mh0 { min-height: 0 !important;}`, "",{"version":3,"sources":["webpack://./src/modules/customComponents/materialTable/materialTable.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,MAAM;;AAEN;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;IACV,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;;;IAGI,cAAc;IACd,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA,eAAe;AACf,QAAQ,sBAAsB,CAAC;AAC/B,QAAQ,uBAAuB,CAAC;;AAEhC,YAAY;;AAEZ,QAAQ,wBAAwB,EAAE,kBAAkB,EAAE;AACtD;IACI,wBAAwB;IACxB,iCAAiC;AACrC;;;AAGA,MAAM,8BAA8B,CAAC;AACrC,MAAM,8BAA8B,CAAC;;AAErC,OAAO,wBAAwB,CAAC","sourcesContent":["div.material-table {\n    box-shadow: 0px 3px 6px #00000029;\n    border-radius: 4px;\n    background-color: #FFFFFF !important;\n}\n\ndiv.material-table .load-bar {\n    position: absolute;\n    top: 57.5px;\n}\n\n/** SCROLL BAR **/\ndiv.material-table .table-scroll::-webkit-scrollbar-thumb:hover {\n    background: #124824;\n}\n\ndiv.material-table .table-scroll::-webkit-scrollbar {\n    margin-right: -5px;\n    width: 5px;\n    height: 5px;\n    border-radius: 5px;\n}\n\ndiv.material-table .table-scroll::-webkit-scrollbar-track {\n    background: #d8d8d8;\n    margin-top: 61.5px;\n    position: absolute;\n}\n\ndiv.material-table .table-scroll::-webkit-scrollbar-thumb {\n    background: #098442;\n}\n\ndiv.material-table .table-scroll::-webkit-scrollbar-thumb:hover {\n    background: #124824;\n}\n\n/*****/\n\ndiv.material-table .table-body .table-row:nth-child(odd) {\n    background-color: #F4F4F4;\n}\n\ndiv.material-table tr.table-header th {\n    background-color: #004B22 !important;\n    color: #FFFFFF !important;;\n    position: sticky !important;\n    top: 0 !important;\n    z-index: 1;\n    height: 50px !important;\n    font: 500 13px/37px 'Roboto';\n}\n\ndiv.material-table tr.table-header th:nth-child(1) {\n    border-top-left-radius: 4px;\n}\ndiv.material-table tr.table-header th:last-child {\n    border-top-right-radius: 4px;\n}\n\ndiv.material-table tr.table-padding th {\n    padding: 4px 4px 4px 4px;\n}\n\n\ndiv.material-table span.sort-header:hover,\ndiv.material-table span.sort-header:focus,\ndiv.material-table span.sort-header.MuiTableSortLabel-active {\n    color: #FFFFFF;\n    font-weight: bold;\n    fill: #FFFFFF !important;\n}\n\ndiv.material-table span.sort-header > svg {\n    fill: #FFFFFF !important;\n}\n\ndiv.material-table tr.table-padding td {\n    padding: 4px 4px 4px 4px;\n}\n\ndiv.material-table td > span.cell-value {\n    color: #424242;\n    font: normal 12px/37px 'Roboto';\n}\n\n/* Dimensions */\n.wfill {width: 100% !important;}\n.hfill {height: 100% !important;}\n\n/* Flexbox */\n\n.flx1 { display: flex !important; flex: 1 !important; }\n.fdc {\n    display: flex !important;\n    flex-direction: column !important;\n}\n\n\n.oxo {overflow-x: overlay !important;}\n.oyo {overflow-y: overlay !important;}\n\n.mh0 { min-height: 0 !important;}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
